import script from "./DashedBorders.vue?vue&type=script&setup=true&lang=js"
export * from "./DashedBorders.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__